const info = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M14.69 14.5H8l-6.73-.04A.31.31 0 0 1 1 14l3.4-6.17 3.33-6.17a.31.31 0 0 1 .54 0l3.33 6.17L15 14a.31.31 0 0 1-.31.5M8.75 6.01h-1.5v1.5h1.5zm0 2.49h-1.5v4.49h1.5z" clip-rule="evenodd"/></svg>',
};

export { info as default };
